import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateCashbackOfferEntity } from '../../domain/entities/CreateCashbackOfferEntity'
import { CashbackBranchRatioModel } from './CashbackBranchRatioModel'
import { CashbackRegionsModel } from './CashbackRegionsModel'
import { CashbackTranslationModel } from './CashbackTranslationModel'

export class CreateCashbackModel extends CreateCashbackOfferEntity {
  declare startDate: string
  declare endDate: string
  declare type: NonNullable<CreateCashbackOfferEntity['type']>
  declare serviceValue: number
  declare branchValue: number
  userIds?: Array<string> | null
  groupIds?: Array<number> | null
  channelIds?: Array<number> | null
  serviceIds?: Array<number> | null
  includeBranchIds?: Array<number> | null
  excludeBranchIds?: Array<number> | null

  constructor(dataDto: CreateCashbackOfferEntity) {
    super()
    mapEntityProperties<CreateCashbackModel>(this, dataDto, {
      exclude: ['users', 'groups', 'channels', 'services', 'includeBranches', 'excludeBranches'],
      map: {
        userIds: dataDto.users?.map((user) => user.id!),
        groupIds: dataDto.groups?.map((group) => group.id!),
        channelIds: dataDto.channels?.map((channel) => channel.id!),
        serviceIds: dataDto.services?.map((service) => service.id!),
        includeBranchIds: dataDto.includeBranches?.map((branch) => branch.id!),
        excludeBranchIds: dataDto.excludeBranches?.map((branch) => branch.id!),
        branchRatios: dataDto.branchRatios?.map((ratio) =>
          new CashbackBranchRatioModel({
            ...ratio,
            branchCap: dataDto.type === 'Percent' ? ratio.branchCap : undefined
          })
        ),
        regions: dataDto.regions?.map((region) => new CashbackRegionsModel(region)),
        translations: dataDto.translations?.map(
          (translation) => new CashbackTranslationModel(translation)
        ),
        variations: dataDto.variations?.map((variation) => ({
          paymentTypes: variation.paymentTypes,
          value: variation.value,
          ...(dataDto.type === 'Percent' && variation.cap !== null && variation.cap !== undefined
            ? { cap: variation.cap }
            : {}),
          translations: variation.translations?.map((translation) => ({
            language: ({ En: 0, Ckb: 1, Ar: 2 } as const)[translation.language],
            name: translation.name,
            description: translation.description
          }))
        }))
      }
    })
    if (dataDto.type !== 'Percent') {
      this.maxCashbackAmount = undefined
      this.branchCap = undefined
    }
  }
}
